import { MaskPattern } from '@/types'

const tokens: any = {
  '#': { pattern: /\d/ },
  X: { pattern: /[0-9a-zA-Z]/ },
  S: { pattern: /[a-zA-Z]/ },
  A: { pattern: /[a-zA-Z]/, transform: (v: any) => v.toLocaleUpperCase() },
  a: { pattern: /[a-zA-Z]/, transform: (v: any) => v.toLocaleLowerCase() },
  '!': { escape: true }
}

export function masker(value: any, mask: any, masked = true) {
  value = value || ''
  mask = mask || ''

  if (mask === MaskPattern.NumberOnly) {
    return value.replace(/\D/g, '')
  } else if (mask === MaskPattern.AlphaMarkNumberOnly) {
    return value.replace(/[^a-zA-Z0-9!-~ ]/g, '')
  } else if (mask === MaskPattern.HalfWidthOnly) {
    return value.replace(/[^ -~]/g, '')
  } else if (mask === MaskPattern.HalfWidthWithKanaOnly) {
    return value.replace(/[^ -~｡-ﾟ]/g, '')
  }

  let iMask = 0
  let iValue = 0
  let output = ''
  while (iMask < mask.length && iValue < value.length) {
    let cMask = mask[iMask]
    const masker = tokens[cMask]
    const cValue = value[iValue]
    if (masker && !masker.escape) {
      if (masker.pattern.test(cValue)) {
        output += masker.transform ? masker.transform(cValue) : cValue
        iMask++
      }
      iValue++
    } else {
      if (masker && masker.escape) {
        iMask++
        cMask = mask[iMask]
      }
      if (masked) output += cMask
      if (cValue === cMask) iValue++
      iMask++
    }
  }

  let restOutput = ''
  if (masked) {
    while (iMask < mask.length) {
      const cMask = mask[iMask]
      if (tokens[cMask]) {
        restOutput = ''
        break
      }
      restOutput += cMask
      iMask++
    }
  }

  return output + restOutput
}
